import type { PerformanceRow } from "@/lib/skills/analytics";

const HEADER = ["Skill", "Views", "Downloads", "Conversion %", "Rating", "Reviews", "Risk"];

/**
 * RFC-4180-ish escaping with spreadsheet formula-injection hardening.
 * - Neutralize cells that would be interpreted as a formula by Excel/Sheets
 *   (leading =, +, -, @, tab, or CR) by prefixing a single quote.
 * - Then wrap in quotes if the cell has a comma, quote, or newline.
 */
function cell(value: string | number): string {
  let s = String(value);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Serialize the analytics performance table to CSV text. */
export function analyticsToCsv(rows: PerformanceRow[]): string {
  const lines = [HEADER.join(",")];
  for (const r of rows) {
    lines.push(
      [
        cell(r.title),
        cell(r.views),
        cell(r.downloads),
        cell(r.conversion),
        cell(r.rating.toFixed(1)),
        cell(r.reviews),
        cell(r.risk),
      ].join(","),
    );
  }
  return `${lines.join("\n")}\n`;
}
